"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkInMintsAreTheSame = exports.getTokenAccountInfo = exports.getMintInfo = exports.splitTokensByFractions = exports.fromReadableNumber = exports.toReadableNumber = exports.removeMints = exports.removeDuplicateMints = exports.createTokenAccountsForActions = exports.getTokenAccountUsedByMalloc = exports.transferToTxChecked = exports.tryCreateAssociatedAccount = exports.tryCreateAssociatedAccountInst = void 0;
const anchor_1 = require("@project-serum/anchor");
const token_instructions_1 = require("@project-serum/serum/lib/token-instructions");
const spl_token_1 = require("@solana/spl-token");
const web3_js_1 = require("@solana/web3.js");
const common_1 = require("@project-serum/common");
const solana_1 = require("./solana");
const tryCreateAssociatedAccountInst = (mint, owner, connection, payer) => __awaiter(void 0, void 0, void 0, function* () {
    const associated = (yield web3_js_1.PublicKey.findProgramAddress([
        owner.toBuffer(),
        spl_token_1.TOKEN_PROGRAM_ID.toBuffer(),
        new web3_js_1.PublicKey(mint).toBuffer(),
    ], spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID))[0];
    const data = yield connection.getAccountInfo(associated);
    if (!data) {
        const inst = spl_token_1.Token.createAssociatedTokenAccountInstruction(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, new web3_js_1.PublicKey(mint), associated, owner, payer);
        return {
            instr: inst,
            associateTokAccount: associated,
        };
    }
    else {
        return {
            associateTokAccount: associated,
        };
    }
});
exports.tryCreateAssociatedAccountInst = tryCreateAssociatedAccountInst;
const tryCreateAssociatedAccount = (mint, owner, provider) => __awaiter(void 0, void 0, void 0, function* () {
    const { associateTokAccount, instr } = yield (0, exports.tryCreateAssociatedAccountInst)(mint, owner, provider.connection, provider.wallet.publicKey);
    if (!instr)
        return associateTokAccount;
    const tx = new web3_js_1.Transaction();
    tx.add(instr);
    yield provider.send(tx);
    return associateTokAccount;
});
exports.tryCreateAssociatedAccount = tryCreateAssociatedAccount;
/**
 * Transfer to the token account being used by a construction input.
 * If the source account does not have enough balance, then throw an error.
 * This will also return null if the source equals the destination.
 * Transfer checked will also check if the mint is Wrapped Sol. If it is
 * and the source account is not a token account, the returned tx will transfer Native Solana
 * from the source
 */
const transferToTxChecked = (source, destination, amount, authority, mint, connection) => __awaiter(void 0, void 0, void 0, function* () {
    const signer = (0, solana_1.conditionallyIncludeSigner)([], authority);
    const isTokAccount = yield isTokenAccount(source, mint, connection);
    // Check if the mint is a wrapped sol mint and if the source is not
    // a token account
    if (mint.equals(token_instructions_1.WRAPPED_SOL_MINT) && !isTokAccount) {
        const nativeBal = yield connection.getBalance(source);
        if (new anchor_1.BN(nativeBal.toString()).lt(amount))
            throw `Expected account ${source.toBase58()} to have at least ${amount.toString()} lamports`;
        const insts = getWrapSolInsts(source, destination, amount);
        const tx = new web3_js_1.Transaction();
        tx.add(...insts);
        return { tx, signers: signer };
    }
    if (!isTokAccount)
        throw `Expected input token account, ${source.toBase58()}, to be a token account`;
    const bal = yield connection.getTokenAccountBalance(source);
    if (new anchor_1.BN(bal.value.amount).lt(amount)) {
        throw `Expected token account for mint ${mint.toBase58()} to have at least ${(0, exports.toReadableNumber)(amount, bal.value.decimals)}`;
    }
    if (source.equals(destination))
        return null;
    const inst = (0, token_instructions_1.transfer)({
        source,
        destination,
        amount,
        owner: authority.publicKey,
    });
    const tx = new web3_js_1.Transaction();
    tx.add(inst);
    return { tx, signers: signer };
});
exports.transferToTxChecked = transferToTxChecked;
/**
 * Get the token account which the malloc sdk will use for a mint
 *
 * @param preferredTokenAccounts - a map of mints to token accounts which the caller would prefer to use per mint. If the account does not exist,
 * and is needed it will be created in the the returned txs
 */
const getTokenAccountUsedByMalloc = (tokenAuthority, mintAccount, preferredTokenAccounts) => __awaiter(void 0, void 0, void 0, function* () {
    const mintAccountPK = new web3_js_1.PublicKey(mintAccount);
    const tokenAuthPk = new web3_js_1.PublicKey(tokenAuthority);
    if (preferredTokenAccounts &&
        preferredTokenAccounts[mintAccountPK.toBase58()]) {
        return preferredTokenAccounts[mintAccountPK.toBase58()];
    }
    return yield findAssociatedTokenAddress(tokenAuthPk, mintAccountPK);
});
exports.getTokenAccountUsedByMalloc = getTokenAccountUsedByMalloc;
/**
 * Takes in a mapping of mints to token accounts. If a token account has yet to exist, one will be made
 * which is associated to the authority's address
 *
 * @param preferredTokenAccounts - a map of mints to token accounts which the caller would prefer to use per mint. If the account does not exist,
 * and is needed it will be created in the the returned txs
 */
const createTokenAccountsForActions = (provider, tokenAuthority, actions, fundingAccount, preferredTokenAccounts) => __awaiter(void 0, void 0, void 0, function* () {
    const allMints = actions
        .map((a) => {
        var _a, _b, _c, _d, _e, _f, _g;
        const mints = [];
        if (((_b = (_a = a.opts) === null || _a === void 0 ? void 0 : _a.tokenCreationOptions) === null || _b === void 0 ? void 0 : _b.skipOutTokenCreations) || false) {
            const skipIdxs = (_c = a.opts) === null || _c === void 0 ? void 0 : _c.tokenCreationOptions.skipOutTokenCreations;
            // Skip all the mints which are included by the skipIdxs
            a.tokenMintOuts.forEach((mint, i) => {
                if (!skipIdxs.includes(i))
                    mints.push(mint);
            });
        }
        else {
            mints.push(...a.tokenMintOuts);
        }
        if (((_e = (_d = a.opts) === null || _d === void 0 ? void 0 : _d.tokenCreationOptions) === null || _e === void 0 ? void 0 : _e.skipInTokenCreation) === true) {
        }
        else {
            mints.push(...a.tokenMintsIn);
        }
        if ((_g = (_f = a.opts) === null || _f === void 0 ? void 0 : _f.tokenCreationOptions) === null || _g === void 0 ? void 0 : _g.extraTokenMintsUsed) {
            mints.push(...a.opts.tokenCreationOptions.extraTokenMintsUsed);
        }
        return mints;
    })
        .flat();
    const mints = (0, exports.removeDuplicateMints)(allMints);
    let accounts = {};
    for (let i = 0; i < mints.length; i++) {
        const mint = mints[i];
        if ((preferredTokenAccounts || {})[mint])
            accounts[mint] = { publicKey: preferredTokenAccounts[mint] };
        // create the token account if not provided
        else {
            const pk = yield findAssociatedTokenAddress(tokenAuthority.publicKey, mint);
            accounts[mint] = {
                publicKey: pk,
            };
        }
    }
    const createTokTx = yield Promise.all(mints.map((mint) => __awaiter(void 0, void 0, void 0, function* () {
        const associatedToSignerAccount = accounts[mint].publicKey;
        const accountExists = yield provider.connection.getAccountInfo(associatedToSignerAccount);
        // Return if the account already exists
        if (accountExists) {
            return null;
        }
        const insts = spl_token_1.Token.createAssociatedTokenAccountInstruction(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, new web3_js_1.PublicKey(mint), accounts[mint].publicKey, tokenAuthority.publicKey, fundingAccount.publicKey);
        const tx = new web3_js_1.Transaction();
        tx.add(insts);
        const signers = (0, solana_1.conditionallyIncludeSigner)([], fundingAccount);
        return {
            tx,
            signers: signers,
        };
    })));
    return { accounts: accounts, txs: createTokTx.filter((i) => !!i) };
});
exports.createTokenAccountsForActions = createTokenAccountsForActions;
// TODO: if there are 2 token accounts of the same type, one of them not being made, then there will be an error out
// See https://spl.solana.com/associated-token-account
const findAssociatedTokenAddress = (walletAddress, tokenMintAddress) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield web3_js_1.PublicKey.findProgramAddress([
        walletAddress.toBuffer(),
        spl_token_1.TOKEN_PROGRAM_ID.toBuffer(),
        new web3_js_1.PublicKey(tokenMintAddress).toBuffer(),
    ], spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID))[0];
});
const removeDuplicateMints = (mints) => [
    ...new Set(mints.map(pkToStr)),
];
exports.removeDuplicateMints = removeDuplicateMints;
const removeMints = (mints, toRemove) => mints.filter((m) => !toRemove.find((toRem) => toRem.equals(m)));
exports.removeMints = removeMints;
const pkToStr = (pk) => pk.toBase58();
const pkFromStr = (pk) => new web3_js_1.PublicKey(pk);
const toReadableNumber = (number, decimals) => {
    function trimTrailingZeroes(value) {
        return value.replace(/\.?0*$/, "");
    }
    function formatWithCommas(value) {
        const pattern = /(-?\d+)(\d{3})/;
        while (pattern.test(value)) {
            value = value.replace(pattern, "$1,$2");
        }
        return value;
    }
    const balance = number.toString();
    const wholeStr = balance.substring(0, balance.length - decimals) || "0";
    const fractionStr = balance
        .substring(balance.length - decimals)
        .padStart(decimals, "0")
        .substring(0, decimals);
    return trimTrailingZeroes(`${formatWithCommas(wholeStr)}.${fractionStr}`);
};
exports.toReadableNumber = toReadableNumber;
const fromReadableNumber = (number, decimals) => {
    function trimLeadingZeroes(value) {
        value = value.replace(/^0+/, "");
        if (value === "") {
            return "0";
        }
        return value;
    }
    const split = number.toString().split(".");
    const wholePart = split[0];
    const fracPart = split[1] || "";
    if (split.length > 2 || fracPart.length > decimals) {
        throw new Error(`Cannot parse '${number}' as token amount`);
    }
    return trimLeadingZeroes(wholePart + fracPart.padEnd(decimals, "0"));
};
exports.fromReadableNumber = fromReadableNumber;
/**
 * Split the amounts and add the remainder to the last amount
 */
const splitTokensByFractions = (amount, splits) => {
    if (splits.length === 0)
        return [];
    const sum = splits.reduce((a, b) => a + b, 0);
    const amounts = splits.map((split) => amount.muln(split).divn(sum));
    const amountSum = amounts.reduce((a, b) => a.add(b), new anchor_1.BN(0));
    const unused = amount.sub(amountSum);
    amounts[amounts.length - 1] = amounts[amounts.length - 1].add(unused);
    return amounts;
};
exports.splitTokensByFractions = splitTokensByFractions;
const getMintInfo = (connection, mintAddr) => __awaiter(void 0, void 0, void 0, function* () {
    const account = yield connection.getAccountInfo(mintAddr);
    if (!account)
        return null;
    return (0, common_1.parseMintAccount)(account.data);
});
exports.getMintInfo = getMintInfo;
const getTokenAccountInfo = (connection, tokenAccount) => __awaiter(void 0, void 0, void 0, function* () {
    const account = yield connection.getAccountInfo(tokenAccount);
    if (!account)
        return null;
    return (0, common_1.parseTokenAccount)(account.data);
});
exports.getTokenAccountInfo = getTokenAccountInfo;
const checkInMintsAreTheSame = (actions) => {
    if (actions.length === 0)
        return true;
    const initMints = actions[0].tokenMintsIn.map((m) => m.toBase58());
    return initMints.every((mint, i) => actions.every((a) => {
        if (a.tokenMintsIn.length <= i) {
            return false;
        }
        return a.tokenMintsIn[i].toBase58() === mint;
    }));
};
exports.checkInMintsAreTheSame = checkInMintsAreTheSame;
/**
 * Get the transaction to wrap sol
 *
 * @param tokenAccount - the token account which contains the wrapped sol.
 * Assume that the account exists
 */
const getWrapSolInsts = (payer, tokenAccount, lamports) => {
    const transferNonWrappedInst = web3_js_1.SystemProgram.transfer({
        programId: spl_token_1.TOKEN_PROGRAM_ID,
        fromPubkey: payer,
        toPubkey: tokenAccount,
        lamports: new anchor_1.BN(lamports).toNumber(),
    });
    const syncInst = spl_token_1.Token.createSyncNativeInstruction(spl_token_1.TOKEN_PROGRAM_ID, tokenAccount);
    return [transferNonWrappedInst, syncInst];
};
const isTokenAccount = (account, expectedMint, connection) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const info = yield (0, exports.getTokenAccountInfo)(connection, account);
        return info.mint.equals(expectedMint);
    }
    catch (e) {
        console.error("Failed to account as token account, assuming that it is not");
        return false;
    }
});
